module.exports = __webpack_public_path__ + "img/bg-ichra.d200d5ea.jpg";